/* action type */
import type { Action } from '../../store/state/state-manager';

export const SUBMIT_BULK_ACTION = 'SUBMIT_BULK_ACTION';

/* action creator */
export const submitBulkAction = (actionPayload: Action['payload']) => {
  return {
    type: SUBMIT_BULK_ACTION,
    payload: actionPayload
  };
};
